
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/products/virtual-accounts",
      function () {
        return require("private-next-pages/docs/api/products/virtual-accounts.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/products/virtual-accounts"])
      });
    }
  